import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * Gets the current labor ticket for the active machine.
 * This is scoped to the current machine via the subscription filter in useRealTimeData.
 * For clock-out flow across all machines, use getClockOutOpenLaborTicketCount instead.
 */
export const getCurrentLaborTicket = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement?.currentLaborTicket;
  }
);
